import { HR, Icon, ICONS, NumberPicker } from '@bob/library'
import { ProductInfoBackorder } from '@websrc/App/Components/Details/ProductInfo/Backorder/ProductInfoBackorder'
import { useStaticText } from '@websrc/App/Hooks/useStaticText'
import { matomo } from '@websrc/App/Tracking/Matomo'
import { useBasketItemQuantity } from '@websrc/Basket/useBasketItemQuantity'
import { useCoralProductMeta, useProductMeta } from '@websrc/Basket/useProductMeta'
import { BasketItem } from '@websrc/Typings/DanteBasket'
import React, { useState } from 'react'

import * as SC from './CartModalItem.style'

export interface ICartModalItemProps {
  item: BasketItem
}

export const CartModalItem = ({ item }: ICartModalItemProps) => {
  const t = useStaticText()
  const productMeta = useProductMeta(item.productNumber)
  const coralProductMeta = useCoralProductMeta(item.productNumber)
  const resolvedProductMeta = productMeta.product_number ? productMeta : coralProductMeta
  const [quantity, setQuantity] = useState(item.quantity)
  useBasketItemQuantity(item, quantity)

  if (!quantity) {
    return null
  }

  const productDetails = {
    product_status: resolvedProductMeta.product_status,
    back_order_date: resolvedProductMeta.back_order_date,
    valid_from_date: resolvedProductMeta.embargo_date,
  }

  const removeItem = () => {
    setQuantity(0)
    matomo.push(['removeEcommerceItem', resolvedProductMeta.product_number])
  }

  return (
    <>
      <SC.Wrapper hidden={!quantity}>
        <SC.ButtonTertiary onClick={removeItem}>
          <Icon icon={ICONS.CROSS} size={13} />
        </SC.ButtonTertiary>
        {resolvedProductMeta.image?.url && (
          <SC.ProductImage lazyLoading={false} thumbnail={resolvedProductMeta.image} width={90} />
        )}
        <SC.ContentWrapper>
          <SC.ProductName>{resolvedProductMeta.name}</SC.ProductName>
          <SC.ProductNumber>{item.productNumber}</SC.ProductNumber>
          <SC.QuanPriceWrapper>
            <SC.QuantityWrapper>
              <SC.QuantityLabel>{t.shopping_cart.quantity_label}</SC.QuantityLabel>
              <NumberPicker onChange={setQuantity} value={quantity} />
            </SC.QuantityWrapper>
            <SC.PriceLabel>{item.totalPrice}</SC.PriceLabel>
          </SC.QuanPriceWrapper>
        </SC.ContentWrapper>
      </SC.Wrapper>
      <ProductInfoBackorder productDetails={productDetails} show={true} />
      {Boolean(quantity) && <HR light={true} />}
    </>
  )
}
